import React, { useState, useEffect } from 'react';
import { Modal, Form, Checkbox, message, Table } from 'antd';
import { createTemplateFile, getTemplateList, getTemplateViewByProjectViewId } from '../../../../api/data-project-view';
import { getViewDetail } from '@/pages/documentCompile/api/templatePackage';
import { useSetState } from 'ahooks';
import { addDocByTemplate, getDocList } from '@/pages/documentCompile/api/data-project-doc';

interface CreateTemplateModalProps {
  requestId?: string;
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  projectId: string;
  folderId?: number;
  viewId?: number;
}
export interface IDocumentTemplate {
  id: string;
  tenantId: string;
  documentId: string;
  documentName: string;
  folderId: number;
  templateId: string;
  viewId: string;
  isDefault: number; // 1 表示默认
  isDelete: number;  // 0 表示未删除
  sortNumber: number;
  createBy: string;
  createAt: string;  // ISO 字符串格式
  updateBy: string;
  updateAt: string;  // ISO 字符串格式
  disabled?: boolean; // 添加disabled属性用于控制checkbox状态
}

const   CreateTemplateModal: React.FC<CreateTemplateModalProps> = ({
  requestId,
  visible,
  onCancel,
  onSuccess,
  projectId,
  folderId,
  viewId
}) => {
  const [form] = Form.useForm();
  const [templateList, setTemplateList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [state, setState] = useSetState<any>({
    tableData: [] as IDocumentTemplate[],
    disabledRows: [] as string[], // 存储需要禁用的行的documentId
  });

  // 获取模板列表
  const fetchTemplateList = async () => {
    try {
      setLoading(true);
      const result = await getTemplateList({ projectId });
      setTemplateList(result?.data || []);
    } catch (error) {
      console.error('获取模板列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      // fetchTemplateList();
    }
  }, [visible, projectId]);

  const handleOk = async () => {
    try {
      const params = {
        projectId: projectId,
        tmplDocIds: selectedKeys,
        folderId: folderId
      }

      await addDocByTemplate(params, requestId);
      message.success('新建模板文件成功');
      setSelectedKeys([]);
      onSuccess();
    } catch (error) {
      message.error('新建模板文件失败');
    }
  };

  const handleCancel = () => {
    setSelectedKeys([]);
    onCancel();
  };

  // 表格列定义
  const columns = [
    {
      title: '模板名称',
      dataIndex: 'documentName',
      key: 'documentName',
      render: (text: string, record: any) => text || record.name,
    },
    // 如有需要可添加更多列
  ];

  // Table rowSelection 配置
  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedKeys(selectedRowKeys);
      form.setFieldsValue({ templateNames: selectedRowKeys });
    },
    getCheckboxProps: (record: IDocumentTemplate) => ({
      disabled: state.disabledRows.includes(record.documentId || record.templateId),
    }),
  };

  const initData = async () => {
    const res = await getTemplateViewByProjectViewId({ viewId, projectId })
    const viewTmplId = res?.viewTmplId
    if (!viewTmplId) return;
    const templateListRes = await getViewDetail(viewTmplId)

    // 假设这里调用 getDocList 接口获取已经存在的文档列表
    try {
      const docListRes = await getDocList({ projectId, viewId }); // 你需要替换成实际的接口调用
      const existingDocIds = (Array.isArray(docListRes) ? docListRes : []).map(doc => doc.tmplDocId) || [];

      setState({
        tableData: templateListRes?.files,
        disabledRows: existingDocIds, // 设置需要禁用的行
      });
    } catch (error) {
      console.error('获取文档列表失败:', error);
      setState({
        tableData: templateListRes?.files,
      });
    }
  }

  useEffect(() => {
    if (visible) {
      setSelectedKeys([]);
      initData()
    }
  }, [visible])

  return (
    <Modal
      title="关联文档模板"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={600}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="文档名称"
          name="templateNames"
          rules={[{ required: true, message: '请选择模板文件' }]}
        >
          <Table
            rowKey={record => record.documentId || record.templateId}
            columns={columns}
            dataSource={state.tableData}
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
            pagination={false}
            scroll={{ y: 400 }}
            size="small"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateTemplateModal; 